import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';

import Markdown from 'components/common/markdown/Markdown';
import { Props } from './Tooltip.interface';
import { tooltipBox, tooltipBox__trigger, tooltipBox__wrapper, tooltipBox__wrapper__arrow } from './Tooltip.scss';

const Tooltip = ({
  trigger,
  id,
  tooltip,
  place = 'right',
  className,
  iconClassName,
  containerClass,
}: Props): JSX.Element => (
  <div className={`${tooltipBox} ${containerClass}`}>
    <button type="button" className={`${iconClassName} ${tooltipBox__trigger} `} data-tooltip-id={id}>
      {trigger}
    </button>
    <ReactTooltip
      id={id}
      className={`${tooltipBox__wrapper} ${className}`}
      classNameArrow={tooltipBox__wrapper__arrow}
      place={place}
      border="5px solid #ccc"
    >
      <Markdown
        source={tooltip}
        container
        listItemIcon={<FontAwesomeIcon icon={faChevronRight} size="sm" aria-label="check icon." />}
      />
    </ReactTooltip>
  </div>
);

export default Tooltip;
